const DFD_DIAGRAM_STORAGE_KEY = 'DFD_DIAGRAM_STORAGE_KEY';

export const getDfdDiagramFromStorage = () : string => {
    return window.localStorage.getItem(DFD_DIAGRAM_STORAGE_KEY);
};

export const setDfdDiagramToStorage = (json: string) => {
    window.localStorage.setItem(DFD_DIAGRAM_STORAGE_KEY, json);
};